import * as React from 'react';
import DocumentTitle from 'react-document-title';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { ErrorView } from '@app/Components/ErrorView/ErrorView';

type ErrorBoundaryState = {
    hasError: boolean;
    error: Error | null;
    componentStack: string | null;
};

type ReportErrorBoundaryProps = React.PropsWithChildren & RouteComponentProps & {
    title: string;
    bodyClassName?: string;
};

class PageErrorBoundary extends React.Component<ReportErrorBoundaryProps, ErrorBoundaryState> {

    constructor(props: ReportErrorBoundaryProps) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            componentStack: null
        };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        this.setState({
            hasError: true,
            error: error,
            componentStack: errorInfo.componentStack || null
        });
    }

    componentDidUpdate(prevProps: ReportErrorBoundaryProps) {
        if (this.state.hasError && prevProps.location.pathname !== this.props.location.pathname) {
            this.setState({ hasError: false, error: null, componentStack: null });
        }
    }

    render() {
        const { title, bodyClassName } = this.props;
        const className = bodyClassName || '';
        return (
            <React.Fragment>
                <DocumentTitle title={title} />
                <div className={className}>
                    {this.state.hasError && <ErrorView error={this.state.error} componentStack={this.state.componentStack} />}
                    {!this.state.hasError && this.props.children}
                </div>
            </React.Fragment>
        );
    }
}

export default withRouter(PageErrorBoundary);